import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import userReducer from '../features/user/userSlice';
import filtersReducer from '../features/filters/filtersSlice';
import experienceReducer from '../features/experience/experienceSlice';
import leadsReducer from '../features/leads/leadsSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    user: userReducer,
    filters: filtersReducer,
    experience: experienceReducer,
    leads: leadsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
